import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { SectionHeading } from "@/accounts-payable/common";
import type { ApVendorListEdit } from "@/accounts-payable/types";
import { EditableChips } from "./editable-chips";

export const ProductLookupsSection = ({
  domains,
  onEditList,
}: {
  domains: string[];
  onEditList: (edit: ApVendorListEdit) => void;
}) => (
  <Stack gap="sm" fullWidth>
    <SectionHeading>Product lookups</SectionHeading>
    <Typography variant="captionW1" textColor="tertiary">
      Pages the agent may read when enriching SKUs.
    </Typography>
    <EditableChips
      values={domains}
      noun="domain"
      placeholder="vendor.com"
      onAdd={(value) =>
        onEditList({ field: "allowed_domains", action: "add", value })
      }
      onRemove={(value) =>
        onEditList({ field: "allowed_domains", action: "remove", value })
      }
    />
  </Stack>
);
